module.exports = {
      id: "location-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#location",
      toString: function () {
        return this.url;
      }
    }